export default "__VITE_ASSET__DG1m2mUW__"